module.exports = __webpack_public_path__ + "static/img/installationGuide02.577503d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/IndexImages/yn/installationGuide02.png
// module id = O23L
// module chunks = 0